import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CrewForm from './CrewForm';
import WhatIf from './WhatIf';
import LoadHistoryPage from '../LoadHistory/LoadHistoryPage';
import CrewKanban from '../crew-kanban/CrewKanban';

const Crew = ({ match }) => {
    return (<Switch>
        <Route exact path={`${match.path}/add`} component={CrewForm} />
        <Route exact path={`${match.path}/edit/:id`} component={CrewForm} />
        <Route exact path={`${match.path}/whatif/:id`} component={WhatIf} />
        <Route exact path={`${match.path}/loadhistory/:crewId`} component={LoadHistoryPage} />
        <Route exact path={`${match.path}/kanban`} component={CrewKanban} />
    </Switch>);
}

export default Crew;